module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "tocitem2"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "bigspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_preface"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENERAL")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/09_foreword"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OREWORD")])])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_introduction",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_explanation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPLANATION OF")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW THE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LD")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTAMENT DESIGNATION")]), _vm._v(" “Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKOV")]), _vm._v("” "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BECAME THE")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTAMENT DESIGNATION")]), _vm._v(", “I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKOBOY")]), _vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Background of The Book: Yalqut, Greek And “The Principal Matter”")])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parashat Kedoshim And Ya’akov")])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who Was Ya’akov? The Man And His Influence")])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Torah Based Concepts Behind The Greek Vocabulary of Yalqut Ya’akov")])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Concept of “Faith And Works”")])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDNOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GLOSSARY")])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_author_biography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHOR")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/21_contributing_author_biography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTRIBUTING")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHOR")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IOGRAPHY")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ade6777e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/06_contents.vue
// module id = 72
// module chunks = 0